// @flow

import { selectTaxesDisplaySetting } from '@gandi/authentication';
import { useTranslator, mapTags } from '@gandi/translate';

import { formatPriceWithDiscount } from 'src/helpers';
import { useAppSelector } from 'src/hooks/useAppSelector';

import { useOffer } from './modules';

import styles from './HostingPackPrice.scss';

type Props = { fqdn: string };

export function HostingPackPrice({ fqdn }: Props): null | React.MixedElement {
  const { __, formatPrice } = useTranslator();
  const displayTaxes = useAppSelector(selectTaxesDisplaySetting);

  const offer = useOffer(fqdn);

  if (!offer) return null;

  const isEssentialOffer = offer.product.name === 'essential';
  const priceWithDiscount = formatPriceWithDiscount(
    offer,
    !isEssentialOffer,
    displayTaxes,
  );

  return (
    <div className={styles.price}>
      {mapTags(__('[[price]]/[[periodicity]]'), () => ({
        price: formatPrice(priceWithDiscount, offer.currency, { round: true }),
        periodicity: __(
          '<for-translators-use>Periodicity (month)</for-translators-use>mo',
        ),
      }))}
    </div>
  );
}
